import React, { useRef, useState, useEffect } from "react";
import { Bar } from "@ant-design/plots";

interface AssetRankBarChartProps {
  data: { priorityName: string; percentage: number }[];
  width: number;
  height: number;
}

const AssetRankBarChart: React.FC<AssetRankBarChartProps> = ({ data, width, height }) => {

  const config = {
    data: data,
    width: width,
    height: height,
    xField: "priorityName",
    yField: "percentage",
    label: false, 
    autofit: true,
    paddingRight: 8,
    style: { radius: 10, fill:'#2f3aa4' },
    axis: { x: { title: false,  labelOpacity:1, labelFontSize:"1vw" }, y: { title: false, } },
  legend: { color: { title: false, position: "left", rowPadding: 5 } 
  },
    tooltip: {
      title:   "priorityName",
    },
    interactions: [{ type: "element-active" }],
  };

  return <Bar {...config}  />;
};

export default AssetRankBarChart;
